package io.horion.cv.models

enum class ExperienceLevel {
    JUNIOR, MID, SENIOR, EXPERT;

    fun getDisplayName(): String {
        return when(this) {
            JUNIOR -> "Junior"
            MID -> "Mid"
            SENIOR -> "Senior"
            EXPERT -> "Expert"
        }
    }
}